import React from 'react';
import Modal from '../../common/Modal';
import FormField from '../../common/FormField';
import { useFormData } from '../../../hooks/useFormData';

/**
 * Tax add/edit modal.
 * Before: 120 lines with duplicate style objects.  After: ~30 lines.
 */

const DEFAULTS = { tax_id: '', tax_rate: '' };

export default function TaxModal({ isOpen, onClose, onSubmit, initialData, title }) {
  const { formData, handleChange } = useFormData(DEFAULTS, initialData, isOpen);

  return (
    <Modal isOpen={isOpen} onClose={onClose} onSubmit={() => onSubmit(formData)} title={title}>
      <div className="flex flex-col gap-1">
        <FormField name="tax_id" label="Tax Code / ID" value={formData.tax_id} onChange={handleChange} required disabled={!!initialData} />
        <FormField name="tax_rate" label="Tax Rate (%)" value={formData.tax_rate} onChange={handleChange} type="number" step="0.01" required />
      </div>
    </Modal>
  );
}
